import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Box, Center, HStack, Link, Text } from "@chakra-ui/layout";
import ImageWebpFormat from "@modules/AppImage/ImageWebpFormat";
import { IProduct } from "@modules/ProductCategory/models/type";
import { Link as GatsbyLink } from "gatsby";
import React, { memo } from "react";

interface Props {
  product: IProduct;
  h: string;
}
const DropDownProductItem: React.FC<Props> = props => {
  const { product, h } = props;

  return (
    <Box>
      <Link
        as={GatsbyLink}
        to={`${product.slug}`}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        h={"full"}
        textDecoration="none"
        _hover={{ textDecoration: "none" }}
      >
        <Center bg="white50" h={h} color="white" mb={"1rem"} mt={"1rem"}>
          <ImageWebpFormat name={product.imgage} />
        </Center>

        <Text textStyle={"h6"} mb={2}>
          {product.name}
        </Text>
        <Text mb={"1rem"}>{product.description}</Text>

        <HStack>
          <Text fontSize={"m"} color={"primary"} fontWeight={700}>
            {product.target_label}
          </Text>
          <ArrowForwardIcon color={"primary"} boxSize={5} />
        </HStack>
      </Link>
    </Box>
  );
};

export default memo(DropDownProductItem);
